import React from 'react';

import Image from '../../Image';
import { CircleCtaButton } from '../HeaderMastheadHalfImage/HeaderMastheadHalfImage.styles';
import {
  CtaSubtitle,
  CtaWrapper,
  ImageOverlay,
  ImageWrapper,
  StyledButtonLink,
  StyledContainer,
  Title,
  Wrapper,
} from './HeaderMastheadFullImage.styles';

const HeaderMastheadFullImage = ({ headerData }) => {
  const { title, image, subTitle, linkTitle, ctaUrl, linkTitle2, ctaUrl2 } = headerData;

  return (
    <Wrapper>
      <ImageWrapper>
        <Image image={image[0]} lazyload={false} />
        <ImageOverlay />
      </ImageWrapper>
      <StyledContainer>
        <Title>{title}</Title>
        {linkTitle2 && ctaUrl2 && (
          <CtaWrapper>
            <StyledButtonLink href={ctaUrl2.url} type={ctaUrl2.type} size="large">
              {linkTitle2}
            </StyledButtonLink>
            {subTitle && <CtaSubtitle>{subTitle}</CtaSubtitle>}
          </CtaWrapper>
        )}
      </StyledContainer>
      {linkTitle && ctaUrl && (
        <CircleCtaButton href={ctaUrl.url} type={ctaUrl.type}>
          {linkTitle}
        </CircleCtaButton>
      )}
    </Wrapper>
  );
};

export default HeaderMastheadFullImage;
